import { IDetailPageData } from "../../../shared/utils/api";

export interface IAlertDatamodelField {
  id: string;
  input_field_name: string;
  field_name: string;
  field_datatype: string;
  primary_key?: string;
  datetime_format?: string;
  text_type?: string;
  distinct_values?: number;
  empty_values?: number;
  null_values?: number;
  archived?: boolean;
}

export interface IAlertBackendType {
  id: string;
  name: string;
  datetime_format?: string;
  csv_separator?: string;
  fields: IAlertDatamodelField[];
  archived?: boolean;
}

export function transformToBackendAlert(data: IDetailPageData): IAlertBackendType | undefined {
  if(!data.id || !data.name){
    return undefined;
  }

  return {
    id: data.id,
    datetime_format: data.datetime_format,
    csv_separator: data.csv_separator,
    name: data.name,
    archived: data.archived,
    fields: data.rowData.map(field => {
      const result:IAlertDatamodelField = {      
        id: field.id,
        input_field_name: field.input_field_name,
        field_name: field.field_name,
        field_datatype: field.field_datatype
      };

      if (field.field_datatype === "text") {
        result.text_type = field.text_type;
      }

      if ((field.text_type && field.text_type !== "long_text" && field.field_datatype === "text") || field.field_datatype === "integer") {
        result.primary_key = field.primary_key;
      }

      if (field.field_datatype === "datetime") {
        result.datetime_format = field.datetime_format;
      }

      return result;
    })
  };
}

export function transformFromBackendAlert(backendType: IAlertBackendType): IDetailPageData {
  return {
    id: backendType.id,
    name: backendType.name,
    archived: backendType.archived,
    datetime_format: backendType.datetime_format,
    csv_separator: backendType.csv_separator,
    rowData: backendType.fields.map(field => {
      const result: any = { // eslint-disable-line
        id: field.id,
        input_field_name: field.input_field_name,
        field_name: field.field_name,
        field_datatype: field.field_datatype,
        empty_values: field.empty_values,
        null_values: field.null_values,
        unique_values: field.distinct_values
      };

      if (field.field_datatype === "text") {
        result.text_type = field.text_type;
      }

      if ((field.text_type && field.text_type !== "long_text" && field.field_datatype === "text") ||  field.field_datatype === "integer") {
        result.primary_key = field.primary_key;
      }

      if (field.field_datatype === "datetime") {
        result.datetime_format = field.datetime_format;
      }

      return result;
    })
  };
}